import * as Focus from '../common/focus';
import { _x } from '@wordpress/i18n';

window.addEventListener('load', function () {
  const toggleSearches = document.querySelectorAll('.toggleSearch');
  const searchModal = document.querySelector('#search-modal');
  const closeSearch = document.querySelector('#search-close');
  const dropdowns = document.querySelectorAll('.nav-primary .dropdown');

  function closeSearchModal() {
    searchModal.classList.remove('opened');
    closeSearch.setAttribute('aria-expanded', 'false');

    toggleSearches.forEach((toggleBtn) => {
      toggleBtn.setAttribute('aria-expanded', 'false');
      toggleBtn.setAttribute(
        'aria-label',
        _x('Open search bar.', 'search button toggle label', 'vtx')
      );
    });

    if (searchModal.classList.contains('search-modal--window')) {
      Focus.untrapFocusInside(jQuery('#search-modal'));
      document.documentElement.classList.remove('lockedPosition');
    }
  }

  function openSearchModal() {
    const openEvent = new Event('opensearchmodal');
    searchModal.classList.add('opened');
    closeSearch.setAttribute('aria-expanded', 'true');
    window.dispatchEvent(openEvent);

    toggleSearches.forEach((toggleBtn) => {
      toggleBtn.setAttribute('aria-expanded', 'true');
      toggleBtn.setAttribute(
        'aria-label',
        _x('Close search bar.', 'search button toggle label', 'vtx')
      );
    });

    setTimeout(() => {
      searchModal.querySelector('input[type=search]').focus();

      if (searchModal.classList.contains('search-modal--window')) {
        Focus.trapFocusInside(jQuery('#search-modal'));
        document.documentElement.classList.add('lockedPosition');
      }
    }, 300);
  }

  if (0 < toggleSearches.length && closeSearch) {
    toggleSearches.forEach((toggleBtn) => {
      toggleBtn.addEventListener('click', function () {
        if (searchModal.classList.contains('opened')) {
          closeSearchModal();
        } else {
          openSearchModal();
        }
      });
    });

    closeSearch.addEventListener('click', function () {
      if (searchModal.classList.contains('opened')) {
        closeSearchModal();
      }
    });

    // close search bar when dropdown opens from hover
    if (
      0 < dropdowns.length &&
      !searchModal.classList.contains('search-modal--window')
    ) {
      dropdowns.forEach(function (dropdown) {
        dropdown.addEventListener('mouseover', function () {
          if (searchModal.classList.contains('opened')) {
            closeSearchModal();
          }
        });
      });
    }
  }
});

// toggle class if search active

document.addEventListener('findstrLoaded', () => {
  const postListing = document.querySelector('.post-listing');
  const resetButton = document.querySelector('.reset-button.resetFilters');
  const searchInput = document.querySelector('#posts-listing_search');

  if (postListing) {
    postListing.classList.add('post-listing__results');

    function updateSearchState() {
      const hasActiveFilters = resetButton && !resetButton.disabled;
      const hasSearchValue = searchInput && searchInput.value.trim() !== '';

      if (hasActiveFilters || hasSearchValue) {
        postListing.classList.add('post-listing__search-active');
      } else {
        postListing.classList.remove('post-listing__search-active');
      }
    }

    updateSearchState();

    if (resetButton) {
      const observer = new MutationObserver(updateSearchState);
      observer.observe(resetButton, {
        attributes: true,
        attributeFilter: ['disabled'],
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', updateSearchState);
    }
  }
});
